export default (state = {}, action) => {
  switch (action.type) {
    case 'APPRELEASE':
      return action.payload;
    default:
      return state;
  }
};
